import type { RuntimeEnvironment } from '../schemas';

export const env: RuntimeEnvironment = process.env.FIRESTORE_EMULATOR_HOST
    ? 'test'
    : (process.env.NODE_ENV! as RuntimeEnvironment);

export const isDevelopment: boolean = env !== 'production' && env !== 'test';
